import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SettingPageCustomTimeRangeFragment } from 'generated/resources/graphql'

import CustomTimeRangeUtils from 'modules/attendance/lib/utils/CustomTimeRangeUtils'

import Content from './Content'

export interface Props {
  timeRanges: SettingPageCustomTimeRangeFragment[]
  base: boolean
}

const Block = ({ timeRanges, base }: Props) => {
  return (
    <Box paddingBottom="s12" gap="s8">
      {timeRanges.map((range, idx) => (
        <Content
          key={`${range.id}_${idx}_${CustomTimeRangeUtils.rangeKey(range)}`}
          range={range}
          base={base}
        />
      ))}
    </Box>
  )
}

export default Block
